
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="1000px"
      transition="dialog-transition"
      style="border-radius: 40px;"
    >
      <base-card>
        <template slot="title">
          <span class="text-capitalize pa-3 font-weight-bold">
            {{ $tc('employees.new')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="employeeForm" class="px-3">
            <div class="black--text">
              {{ $t('employees.main_data_form_label') }}
            </div>

            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="12" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.full_name_form_label')"
                  v-model="new_employee.name"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.cpf_form_label')"
                  v-model="new_employee.cpf"
                  :rules="cpf"
                  v-mask='"###.###.###-##"'
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.cau_form_label')"
                  v-model="new_employee.cau"
                  :rules="required"
                ></v-text-field>
              </v-col>
              
            </v-row>

            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="6" md="4" v-if="new_employee.document_kind == 'cpf'">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.rg_form_label')"
                  v-model="new_employee.rg"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.phone_form_label')"
                  v-model="new_employee.phone"
                  :rules="required"
                  v-mask='((new_employee.phone && new_employee.phone.length) < 15) ? "(##) ####-####" : "(##) # ####-####"'
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.email_form_label')"
                  v-model="new_employee.email"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.rg_form_label')"
                  v-model="new_employee.rg"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.occupation_form_label')"
                  v-model="new_employee.occupation"
                  :rules="required"
                ></v-text-field>
              </v-col>

              
              <v-col class="py-0" cols="12" sm="6" md="4">
                <vc-date-picker v-model="new_employee.birthdate">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$t('employees.birthdate_form_label')"
                      :value="new_employee.birthdate && $dayjs(new_employee.birthdate).format('DD/MM/YYYY') || ''"
                      :rules="required"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <vc-date-picker v-model="new_employee.hired_date">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$t('employees.hired_date_form_label')"
                      :value="new_employee.hired_date && $dayjs(new_employee.hired_date).format('DD/MM/YYYY') || ''"
                      :rules="required"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <vc-date-picker v-model="new_employee.fired_date">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$t('employees.fired_date_form_label')"
                      :value="new_employee.fired_date && $dayjs(new_employee.fired_date).format('DD/MM/YYYY') || ''"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
            </v-row>

            <div class="black--text my-3">
              {{ $t('employees.address_form_label') }}
            </div>

            <address-form ref="address_form" :validate_form="true" :address="new_employee.address"></address-form>

            <div class="black--text my-3">
              {{ $t('employees.bank_account_form_label') }}
            </div>


            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.bank_form_label')"
                  v-model="new_employee.bank"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.agency_form_label')"
                  v-model="new_employee.agency"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.account_form_label')"
                  v-model="new_employee.account"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.pix_form_label')"
                  v-model="new_employee.pix"
                  :rules="required"
                ></v-text-field>
              </v-col>
              
            </v-row>


            <div class="black--text my-3">
              {{ $t('employees.permission_form_label') }}
            </div>

            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-select rounded outlined dense class="rounder" 
                  :label="$t('employees.role_form_label')"
                  v-model="new_employee.role_ids"
                  :rules="required"
                  :items="roles"
                  item-text="translated"
                  item-value="id"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </template>


        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancelEmployee" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="saveEmployee" text>{{ $t('save') }}</v-btn>
        </template>

      </base-card>
    </v-dialog>

    <dialog-loading v-if="loading" loadingText="saving" ></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import AddressForm from '../shared/forms/AddressForm.vue';

export default {
  name: 'DialogCreateEmployee',
  mixins: [ validations ],
  components: {
    AddressForm
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,

      loading: false,
      
      new_employee: {
        name: null,
        cpf: null,
        status: 'active',
        // json_attributes
        phone: null,
        rg: null,
        email: null,
        bank: null,
        agency: null,
        account: null,
        pix: null,
        occupation: null,
        birthdate: null,
        hired_date: null,
        fired_date: null,

        address: {
          street: null,
          number: null,
          district: null,
          city: null,
          state: null,
          zip: null,
          complement: null,
        },

        company_id: null,
        role_ids: [],
      },

      loading_roles: false,
      roles: [],
      occupations: []
    }
  },
  methods: {
    cancelEmployee(){
      this.dialog=false
    },
    saveEmployee(){
      if (this.$refs.employeeForm.validate()){
        this.loading = true
        let emp = this.prepareEmployee()
        Api.Employee.create(emp).then(r=> {
          this.$router.go(-1)
        }).catch(err=> {
          console.log({err});
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    prepareEmployee(){
      let {status, company_id, role_ids, ...user} = this.new_employee

      let user_attributes = {
        ...user,
        password: '1029#azo$app',
        password_confirmation: '1029#azo$app',
        // name: null,
        // cpf: null,
        // phone: null,
        // rg: null,
        // email: null,
        // bank: null,
        // agency: null,
        // account: null,
        // pix: null,
        // occupation: null,
        // birthdate: null,
        // hired_date: null,
        // fired_date: null,

        // address: {
        //   street: null,
        //   number: null,
        //   district: null,
        //   city: null,
        //   state: null,
        //   zip: null,
        //   complement: null,
        // },
      }
      
      let obj = {
        user_attributes,
        status, 
        role_ids: [role_ids].flat(), 
        company_id, 
      }
      return obj 
    },
    getRoles(){
      this.loading_roles = true
      Api.Role.index().then(r=> {
        this.roles = [...r.data.map(d=> {
          let translated = this.$t(`employees.roles.${d.name}`)
          return {...d, translated}
        })]
        this.occupations = [...this.roles]
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        this.loading_roles = false
      })
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      profile: (state) => state.User.oneUser,
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getRoles();
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
  
      } else if (nv == false){
        this.$router.go(-1)
      }
    }
  },
}
</script>

<style scoped>

</style>